import { useRecoilTransactionObserver_UNSTABLE } from 'recoil';

export function RecoilDebugger() {
  useRecoilTransactionObserver_UNSTABLE(({ snapshot, previousSnapshot }) => {
    for (const modifiedAtom of Array.from(snapshot.getNodes_UNSTABLE({ isModified: true }))) {
      const newValue = snapshot.getLoadable(modifiedAtom).contents;
      const oldValue = previousSnapshot.getLoadable(modifiedAtom).contents;
      console.log(`[Recoil] ${modifiedAtom.key}:`, {
        from: oldValue,
        to: newValue,
      });
    }
  });

  return null;
}